<main
  class="jobs-full-page"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <ng-container *ngIf="contentReady; else pageBootLoader">
    <section class="jobs-hero">
      <div class="jobs-hero-bg"></div>

      <div class="atw-container jobs-hero-inner">
        <span class="hero-badge">
          <span>ElShahat IN</span>
          {{ t('heroEyebrow') }}
        </span>

        <h1>{{ t('heroTitle') }}</h1>

        <p>
          {{ t('heroSubtitle') }}
        </p>

        <div class="jobs-search-panel">
          <label class="search-field main-search">
            <i>
              <img class="img-m" src="assets/as/2.webp" alt="search" />
            </i>

            <input
              type="text"
              [value]="filters.search"
              [placeholder]="t('searchPlaceholder')"
              (input)="onTextInput($event, 'search')"
              (keydown.enter)="applyFilters()"
            />
          </label>

          <label class="search-field">
            <i>
              <img class="img-m" src="assets/as/1.webp" alt="country" />
            </i>

            <select
              [value]="filters.country_id"
              (change)="onCountryChange($event, false)"
            >
              <option value="">{{ t('allCountries') }}</option>
              <option
                *ngFor="let country of countries; trackBy: trackById"
                [value]="country.id"
              >
                {{ getCountryLabel(country) }}
              </option>
            </select>
          </label>

          <button
            type="button"
            class="primary-action hero-search-btn"
            (click)="applyFilters()"
          >
            {{ t('searchJobs') }}

          </button>
        </div>
      </div>
    </section>

    <section class="atw-container jobs-content">
      <aside class="jobs-filters-card desktop-filters-card">
        <div class="filters-head">
          <h2>{{ t('filters') }}</h2>

          <button
            type="button"
            class="reset-filter"
            [disabled]="!hasFilters"
            (click)="resetFilters()"
          >
            {{ t('resetAll') }}
          </button>
        </div>

        <div class="filter-group">
          <h3>{{ t('jobType') }}</h3>

          <div class="filter-options">
            <button
              type="button"
              class="filter-pill"
              [class.active]="!filters.employment_type"
              (click)="setOptionFilter('employment_type', '')"
            >
              {{ t('allJobTypes') }}
            </button>

            <button
              type="button"
              class="filter-pill"
              *ngFor="let type of employmentTypeOptions"
              [class.active]="filters.employment_type === type.value"
              (click)="setOptionFilter('employment_type', type.value)"
            >
              {{ isAr ? type.labelAr : type.labelEn }}
            </button>
          </div>
        </div>

        <div class="filter-group">
          <h3>{{ t('workModel') }}</h3>

          <div class="filter-options">
            <button
              type="button"
              class="filter-pill"
              [class.active]="!filters.work_model"
              (click)="setOptionFilter('work_model', '')"
            >
              {{ t('allWorkModels') }}
            </button>

            <button
              type="button"
              class="filter-pill"
              *ngFor="let model of workModelOptions"
              [class.active]="filters.work_model === model.value"
              (click)="setOptionFilter('work_model', model.value)"
            >
              {{ isAr ? model.labelAr : model.labelEn }}
            </button>
          </div>
        </div>

        <div class="filter-group">
          <h3>{{ t('location') }}</h3>

          <label class="side-select">
            <span>{{ t('country') }}</span>
            <select
              [value]="filters.country_id"
              (change)="onCountryChange($event, true)"
            >
              <option value="">{{ t('allCountries') }}</option>
              <option
                *ngFor="let country of countries; trackBy: trackById"
                [value]="country.id"
              >
                {{ getCountryLabel(country) }}
              </option>
            </select>
          </label>

          <label class="side-select">
            <span>{{ t('city') }}</span>
            <select
              [value]="filters.city_id"
              (change)="onSelectFilter($event, 'city_id', true)"
            >
              <option value="">{{ t('allCities') }}</option>
              <option
                *ngFor="let city of filteredCities; trackBy: trackById"
                [value]="city.id"
              >
                {{ getCityLabel(city) }}
              </option>
            </select>
          </label>
        </div>
      </aside>

      <section class="jobs-results">
        <div class="results-head">
          <div>
            <h2>{{ t('latestOpportunities') }}</h2>

            <p>
              {{ formatNumber(totalJobsCount) }}
              {{ t('jobsFound') }}
            </p>
          </div>

          <div class="results-actions">
            <button
              type="button"
              class="secondary-action mobile-filter-trigger"
              (click)="openFiltersModal()"
            >
              ☰
              {{ t('filters') }}
              <span class="filter-active-dot" *ngIf="hasFilters"></span>
            </button>

            <button
              type="button"
              class="secondary-action"
              (click)="shareSearch()"
            >
              {{ t('shareSearch') }}
            </button>
          </div>
        </div>

        <p class="share-message" *ngIf="shareMessage">
          {{ shareMessage }}
        </p>

        <div class="jobs-loading" *ngIf="isLoading">
          <span></span>
          <p>{{ t('loading') }}</p>
        </div>

        <div class="empty-jobs" *ngIf="!isLoading && !jobs.length">
          <h3>{{ t('emptyTitle') }}</h3>
          <p>{{ t('emptyText') }}</p>

          <button
            type="button"
            class="primary-action"
            *ngIf="hasFilters"
            (click)="resetFilters()"
          >
            {{ t('resetAll') }}
↺
          </button>
        </div>

        <div class="jobs-grid" *ngIf="!isLoading && jobs.length">
          <article
            class="jobs-card"
            *ngFor="let job of jobs; trackBy: trackByJobId"
          >
            <button
              type="button"
              class="card-share"
              (click)="goJobDetails(job)"
              aria-label="Open job"
            >
     ↗
            </button>

            <div class="job-card-head">
              <img class="img-l" src="assets/as/9.webp" alt="company" />

              <div>
                <h3>{{ getJobTitle(job) }}</h3>

                <p>
                  {{ getCompanyName(job) }}
                </p>
              </div>
            </div>

            <div class="job-location-line">
              <span>
                <img class="img-m" src="assets/as/21.webp" alt="location" />
                {{ getCityName(job) }}, {{ getCountryName(job) }}
              </span>

              <span>•</span>

              <span>
                <img class="img-m" src="assets/as/41.webp" alt="time" />
                {{ getPostedAt(job) }}
              </span>
            </div>

            <strong class="job-salary">
              {{ getSalary(job) }}
            </strong>

            <div class="job-meta">
              <small>
                <img class="img-m" src="assets/as/4.webp" alt="job type" />
                {{ getJobType(job) }}
              </small>

              <small>
                <img class="img-m" src="assets/as/1.webp" alt="work model" />
                {{ getWorkModel(job) }}
              </small>

              <small>
                <img class="img-m" src="assets/as/19.webp" alt="views" />
                {{ formatNumber(job.views_count || 0) }}
              </small>
            </div>

            <div class="job-keywords" *ngIf="getTags(job, 3).length">
              <small *ngFor="let tag of getTags(job, 3)">
                {{ tag }}
              </small>
            </div>

            <div class="job-card-actions">
              <button
                type="button"
                class="secondary-action"
                (click)="openJobDetails(job)"
              >
                {{ t('details') }}
              </button>

              <button
                *ngIf="!isCompanyUser()"
                type="button"
                class="primary-action"
                (click)="applyForJob(job)"
                [disabled]="isJobApplied(job)"
              >
                {{ getApplyButtonLabel(job) }}

              </button>
            </div>
          </article>
        </div>

        <div class="jobs-pagination" *ngIf="!isLoading && lastPage > 1">
          <button
            type="button"
            class="page-btn"
            [disabled]="currentPage <= 1"
            (click)="goToPage(currentPage - 1)"
          >
            <img class="img-s" src="assets/as/5.webp" alt="previous" />
          </button>

          <button
            type="button"
            class="page-btn"
            *ngFor="let page of pages"
            [class.active]="page === currentPage"
            (click)="goToPage(page)"
          >
            {{ formatNumber(page) }}
          </button>

          <button
            type="button"
            class="page-btn"
            [disabled]="currentPage >= lastPage"
            (click)="goToPage(currentPage + 1)"
          >
            <img class="img-s" src="assets/as/6.webp" alt="next" />
          </button>
        </div>
      </section>
    </section>
  </ng-container>

  <ng-template #pageBootLoader>
    <div class="atw-container">
      <div class="jobs-loading page-loader">
        <span></span>
        <p>{{ t('loading') }}</p>
      </div>
    </div>
  </ng-template>
</main>

<div
  class="mobile-filters-backdrop"
  *ngIf="filtersModalOpen"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
  (click)="closeFiltersModal()"
>
  <div class="mobile-filters-panel" (click)="$event.stopPropagation()">
    <button
      type="button"
      class="mobile-filters-close"
      (click)="closeFiltersModal()"
    >
      ✕
    </button>

    <aside class="jobs-filters-card mobile-filters-card">
      <div class="filters-head">
        <h2>{{ t('filters') }}</h2>

        <button
          type="button"
          class="reset-filter"
          [disabled]="!hasMobileFilters"
          (click)="resetMobileFilters()"
        >
          {{ t('resetAll') }}
        </button>
      </div>

      <div class="filter-group">
        <h3>{{ t('jobType') }}</h3>

        <div class="filter-options">
          <button
            type="button"
            class="filter-pill"
            [class.active]="!mobileFilters.employment_type"
            (click)="setMobileOptionFilter('employment_type', '')"
          >
            {{ t('allJobTypes') }}
          </button>

          <button
            type="button"
            class="filter-pill"
            *ngFor="let type of employmentTypeOptions"
            [class.active]="mobileFilters.employment_type === type.value"
            (click)="setMobileOptionFilter('employment_type', type.value)"
          >
            {{ isAr ? type.labelAr : type.labelEn }}
          </button>
        </div>
      </div>

      <div class="filter-group">
        <h3>{{ t('workModel') }}</h3>

        <div class="filter-options">
          <button
            type="button"
            class="filter-pill"
            [class.active]="!mobileFilters.work_model"
            (click)="setMobileOptionFilter('work_model', '')"
          >
            {{ t('allWorkModels') }}
          </button>

          <button
            type="button"
            class="filter-pill"
            *ngFor="let model of workModelOptions"
            [class.active]="mobileFilters.work_model === model.value"
            (click)="setMobileOptionFilter('work_model', model.value)"
          >
            {{ isAr ? model.labelAr : model.labelEn }}
          </button>
        </div>
      </div>

      <div class="filter-group">
        <h3>{{ t('location') }}</h3>

        <label class="side-select">
          <span>{{ t('country') }}</span>
          <select
            [value]="mobileFilters.country_id"
            (change)="onMobileCountryChange($event)"
          >
            <option value="">{{ t('allCountries') }}</option>
            <option
              *ngFor="let country of countries; trackBy: trackById"
              [value]="country.id"
            >
              {{ getCountryLabel(country) }}
            </option>
          </select>
        </label>

        <label class="side-select">
          <span>{{ t('city') }}</span>
          <select
            [value]="mobileFilters.city_id"
            (change)="onMobileSelectFilter($event, 'city_id')"
          >
            <option value="">{{ t('allCities') }}</option>
            <option
              *ngFor="let city of mobileFilteredCities; trackBy: trackById"
              [value]="city.id"
            >
              {{ getCityLabel(city) }}
            </option>
          </select>
        </label>
      </div>
    </aside>

    <div class="mobile-filters-actions">
      <button
        type="button"
        class="secondary-action"
        (click)="closeFiltersModal()"
      >
        {{ t('close') }}
      </button>

      <button
        type="button"
        class="primary-action"
        (click)="applyMobileFilters()"
      >
        {{ t('searchJobs') }}
      </button>
    </div>
  </div>
</div>

<div
  class="job-modal-backdrop"
  *ngIf="modalOpen"
  (click)="closeJobDetails()"
>
  <div class="job-modal" (click)="$event.stopPropagation()">
    <button type="button" class="job-modal-close" (click)="closeJobDetails()">
      <img class="img-s" src="assets/as/7.webp" alt="close" />
    </button>

    <div class="jobs-loading modal-loader" *ngIf="isDetailsLoading">
      <span></span>
      <p>{{ t('loading') }}</p>
    </div>

    <ng-container *ngIf="selectedJob && !isDetailsLoading">
      <div class="job-modal-hero">
        <div class="job-modal-title-area">
          <small class="modal-status-pill">
            <span class="modal-pill-icon">
              <img class="img-s" src="assets/as/27.webp" alt="status" />
            </span>
            {{ getStatusLabel(selectedJob.status) }}
          </small>

          <h2>{{ getJobTitle(selectedJob) }}</h2>

          <div class="modal-company-line">
            <span>
              <img class="img-m" src="assets/as/9.webp" alt="company" />
              {{ getCompanyName(selectedJob) }}
            </span>

            <span>
              <img class="img-m" src="assets/as/21.webp" alt="location" />
              {{ getCityName(selectedJob) }},
              {{ getCountryName(selectedJob) }}
            </span>
          </div>
        </div>

        <div class="job-modal-salary">
          <div class="salary-icon">
            <img class="img-m" src="assets/as/4.webp" alt="salary" />
          </div>

          <div>
            <span>{{ t('salary') }}</span>
            <strong>{{ getSalary(selectedJob) }}</strong>
          </div>
        </div>
      </div>

      <div class="job-details-grid">
        <div class="detail-card">
          <img class="img-m" src="assets/as/4.webp" alt="employment type" />
          <span>{{ t('employmentType') }}</span>
          <strong>{{ getJobType(selectedJob) }}</strong>
        </div>

        <div class="detail-card">
          <img class="img-m" src="assets/as/1.webp" alt="work model" />
          <span>{{ t('workModel') }}</span>
          <strong>{{ getWorkModel(selectedJob) }}</strong>
        </div>

        <div class="detail-card">
          <img class="img-m" src="assets/as/34.webp" alt="posted at" />
          <span>{{ t('postedAt') }}</span>
          <strong>{{ getPostedAt(selectedJob) }}</strong>
        </div>

        <div class="detail-card">
          <img class="img-m" src="assets/as/19.webp" alt="views" />
          <span>{{ t('views') }}</span>
          <strong>{{ formatNumber(selectedJob.views_count || 0) }}</strong>
        </div>

        <div class="detail-card" [class.active-warning]="selectedJob.exam_required">
          <img class="img-m" src="assets/as/17.webp" alt="exam required" />
          <span>{{ t('examRequired') }}</span>
          <strong>{{ selectedJob.exam_required ? t('yes') : t('no') }}</strong>
        </div>

        <div
          class="detail-card"
          [class.active-warning]="selectedJob.personality_assessment_required"
        >
          <img class="img-m" src="assets/as/26.webp" alt="assessment" />
          <span>{{ t('personalityAssessment') }}</span>
          <strong>
            {{
              selectedJob.personality_assessment_required
                ? t('yes')
                : t('no')
            }}
          </strong>
        </div>
      </div>

      <div class="job-modal-section" *ngIf="getJobDescription(selectedJob)">
        <h3>
          <img class="img-m" src="assets/as/12.webp" alt="description" />
          {{ t('description') }}
        </h3>

        <p>{{ getJobDescription(selectedJob) }}</p>
      </div>

      <div class="job-modal-section" *ngIf="getJobResponsibilities(selectedJob)">
        <h3>
          <img class="img-m" src="assets/as/27.webp" alt="responsibilities" />
          {{ t('responsibilities') }}
        </h3>

        <p>{{ getJobResponsibilities(selectedJob) }}</p>
      </div>

      <div class="job-modal-section" *ngIf="getTags(selectedJob).length">
        <h3>
          <img class="img-m" src="assets/as/8.png" alt="skills" />
          {{ t('skills') }}
        </h3>

        <div class="job-keywords modal-tags">
          <small *ngFor="let tag of getTags(selectedJob)">
            {{ tag }}
          </small>
        </div>
      </div>

      <div class="job-modal-section" *ngIf="getRequirements(selectedJob).length">
        <h3>
          <img class="img-m" src="assets/as/35.webp" alt="requirements" />
          {{ t('requirements') }}
        </h3>

        <ul class="requirements-list">
          <li
            *ngFor="
              let req of getRequirements(selectedJob);
              trackBy: trackByRequirementId
            "
          >
            <span class="req-icon">•</span>

            <div>
              <strong>
                {{ getRequirementTypeLabel(req.requirement_type) }}:
              </strong>

              {{ getRequirementText(req) }}

              <small *ngIf="req.is_required">
                {{ t('required') }}
              </small>
            </div>
          </li>
        </ul>
      </div>

      <div class="job-modal-actions">
        <button
          type="button"
          class="secondary-action"
          (click)="closeJobDetails()"
        >
✕
          {{ t('close') }}
        </button>

        <button
          *ngIf="!isCompanyUser()"
          type="button"
          class="primary-action"
          (click)="applyForJob(selectedJob)"
          [disabled]="isJobApplied(selectedJob)"
        >

          {{ getApplyNowButtonLabel(selectedJob) }}
        </button>
      </div>
    </ng-container>
  </div>
</div>

<div
  class="apply-modal-backdrop"
  *ngIf="applyModalOpen && !isCompanyUser()"
  (click)="closeApplyModal()"
>
  <div class="apply-modal" (click)="$event.stopPropagation()">
    <button
      type="button"
      class="apply-modal-close"
      (click)="closeApplyModal()"
    >
     ✕
    </button>

    <div class="apply-modal-head" *ngIf="selectedApplyJob">
      <span>{{ t('applyNow') }}</span>

      <h2>{{ getJobTitle(selectedApplyJob) }}</h2>

      <p>
        {{ getCompanyName(selectedApplyJob) }}
        • {{ getCityName(selectedApplyJob) }},
        {{ getCountryName(selectedApplyJob) }}
      </p>
    </div>

    <div class="apply-modal-body">
      <app-atw-cv-uploader
        *ngIf="getApplicationFormType(selectedApplyJob) === 'general'"
        [jobId]="selectedApplyJob?.id"
        (applicationSubmitted)="handleApplicationSubmitted()"
      ></app-atw-cv-uploader>

      <app-applyfordoctor
        *ngIf="getApplicationFormType(selectedApplyJob) === 'doctor'"
        [jobId]="selectedApplyJob?.id"
        (applicationSubmitted)="handleApplicationSubmitted()"
      ></app-applyfordoctor>

      <app-applyfordentist
        *ngIf="getApplicationFormType(selectedApplyJob) === 'dentist'"
        [jobId]="selectedApplyJob?.id"
        (applicationSubmitted)="handleApplicationSubmitted()"
      ></app-applyfordentist>
    </div>
  </div>
</div>
